import React from 'react';
import { Check } from 'lucide-react';

export const Stepper = ({ steps, current, onSelect, canGoTo }) => (
  <div data-testid="wizard-stepper" className="flex items-center gap-1 overflow-x-auto pb-1">
    {steps.map((s, i) => {
      const n = i + 1;
      const done = current > n;
      const active = current === n;
      const allowed = canGoTo ? canGoTo(n) : true;
      return (
        <React.Fragment key={s.title}>
          <button
            type="button"
            data-testid={`wizard-step-${n}`}
            disabled={!allowed}
            onClick={() => allowed && onSelect(n)}
            className={[
              'flex shrink-0 items-center gap-2.5 rounded-[12px] px-2.5 py-2 text-left transition-colors duration-150',
              allowed ? 'hover:bg-[hsl(var(--surface-2))]' : 'cursor-not-allowed opacity-50',
              active ? 'bg-[hsl(var(--surface-2))]' : '',
            ].join(' ')}
          >
            <span
              className={[
                'grid h-8 w-8 shrink-0 place-items-center rounded-full border text-xs font-semibold',
                done
                  ? 'border-[hsl(var(--brand-red))] bg-[hsl(var(--brand-red))] text-white'
                  : active
                  ? 'border-[hsl(var(--brand-red))] text-white ring-2 ring-[hsl(var(--brand-red))]/30'
                  : 'border-[hsl(var(--border-strong))] text-[hsl(var(--text-muted))]',
              ].join(' ')}
            >
              {done ? <Check className="h-4 w-4" /> : n}
            </span>
            <span className="hidden sm:block">
              <span
                className={[
                  'block text-[13px] font-semibold leading-tight',
                  active ? 'text-white' : 'text-[hsl(var(--text-muted))]',
                ].join(' ')}
              >
                {s.title}
              </span>
              <span className="block text-[11px] text-[hsl(var(--text-muted))]">{s.hint}</span>
            </span>
          </button>
          {i < steps.length - 1 && (
            <span className="h-px w-4 shrink-0 bg-[hsl(var(--border-strong))] sm:w-6" />
          )}
        </React.Fragment>
      );
    })}
  </div>
);
